import { useGetUpcomingEventsForUser, isUserAllowedToHandleEvent } from '../../../FrontEndReact/src/Core/Services/event';
import ObjectMiniList, { ListObject, ObjectType } from '../../Components/ObjectMiniList';
import { Event, EventStatus, ParticipationStatus } from '../../../FrontEndReact/src/Core/Types/event';
import { formatDate } from '../../../FrontEndReact/src/Core/Utils/dateUtils';
import { useGetUserSession } from '../../../FrontEndReact/src/Core/Hooks/useUser';
import './EventList.scss';
//import useWindowSize from '../../../FrontEndReact/src/Core/Hooks/useWindowSize';
import BizPhrase from '../../Components/Phrase';
//import { goto } from '../../../Js/React/Services/legacy';

type EventListProps = {
	eventFilter?: string;
};

const EventList = ({ eventFilter }: EventListProps) => {
	const events = useGetUpcomingEventsForUser();
	//const { isMobile } = useWindowSize();
	const loggedInUserSession = useGetUserSession();

	console.log('events', events);

	if (!events) return null;

	// const goToEvent = (eventId: number) => {
	// 	goto('base.modules.event', { id: eventId });
	// };

	const allowedToHandlerEvent = (event: Event) => {
		return loggedInUserSession !== undefined && loggedInUserSession !== null
			? isUserAllowedToHandleEvent(event, loggedInUserSession.User)
			: false;
	};

	const mapToListObject = (event: Event): ListObject => {
		return {
			Id: event.Id,
			Name: event.Name,
			Description:
				event.Location +
				(eventFilter ? ' - ' + (!allowedToHandlerEvent(event) ? event.Description : event?.ShortDescription ?? '') : ''),
			ImageUrl: event.ImageUrl ?? '',
			EngageObjects: [],
			Url: { state: 'base.modules.event', params: { id: event.Id } },
			OverrideTypeLabels: [
				{ type: 'EVENT' as ObjectType, overrideLabel: formatDate(event.StartDateTimeUtc, 'd MMMM'), overrideIcon: '' },
				...(event.UserStatus === ParticipationStatus.Attending ||
				event.UserStatus === ParticipationStatus.ConfirmedAttended
					? [{ type: 'EVENT' as ObjectType, overrideLabel: 'Anmäld', overrideIcon: '' }]
					: []),
			],
			BannerText: event.Status === EventStatus.Cancelled ? 'Inställt!' : undefined,
		};
	};

	if (!eventFilter) {
		//isMobile &&
		const noRsvpEvents = events.filter((e) => e.DoNotRequireRSVP);
		const rsvpEvents = events.filter((e) => !e.DoNotRequireRSVP);

		const rsvpListObjects: ListObject[] = rsvpEvents.map(mapToListObject);
		const noRsvpListObjects: ListObject[] = noRsvpEvents.map(mapToListObject);

		if (rsvpListObjects.length === 0 && noRsvpListObjects.length === 0) return null;

		return (
			<div className='user-event-list'>
				{rsvpListObjects.length > 0 && (
					<div className='user-event-list-rsvp-events'>
						<h2 className='biz-sub-header'>
							<BizPhrase phraseKey='EVENTLIST.RSVP_LIST.HEADER'></BizPhrase>
						</h2>
						<ObjectMiniList objects={rsvpListObjects} layoutMobile='carousel' layout='hero' type='EVENT' />
					</div>
				)}
				{noRsvpListObjects.length > 0 && (
					<div className='user-event-list-norsvp-events'>
						<h2 className='biz-sub-header'>
							<BizPhrase phraseKey='EVENTLIST.NO_RSVP_LIST.HEADER'></BizPhrase>
						</h2>
						<ObjectMiniList objects={noRsvpListObjects} layoutMobile='carousel' layout='hero' type='EVENT' />
					</div>
				)}
			</div>
		);
	}

	const filteredEvents = eventFilter
		? events.filter((e) => (eventFilter === 'open' && e.DoNotRequireRSVP) || (eventFilter !== 'open' && !e.DoNotRequireRSVP))
		: events;

	const listObjects: ListObject[] = filteredEvents.map(mapToListObject);

	//temp until we make a better generic list module

	return (
		<div className='user-event-list'>
			<ObjectMiniList objects={listObjects} type='EVENT' limit={99} />
		</div>
	);
};

export default EventList;
